export enum UserRole {
  Business = 'DSB_Businessuser',
  Technical = 'DSB_Technicaluser'
}

export interface AuthUser {
  id: string;
  name: string;
  email: string;
  roles: string[];
  role?: UserRole;
}

export interface UserInfo {
  token: string;
  userName: string;
  userRoles: UserRole[];
}

export interface AuthContextValue {
  user: AuthUser | null;
  token?: string;
  availableRoutes: string[];
  isAuthenticated: boolean;
  triggerInit: (userInfo: UserInfo) => void;
  signout: () => void;
}
